import React from 'react';

/**
 * Fiskekrok-ikon i samme lucide-stil som resten av appens ikoner (kun
 * strøk, ingen fyll, stroke-width 2, avrundede ender/hjørner). Brukes for
 * «Hvor er sniken?»-inngangene i hovedmenyen og for «Sett snik»-knappen
 * inni Snikkart. Ligger i egen fil (i stedet for f.eks. inni Snikkart.js)
 * slik at App.js kan bruke den uten å trekke inn Leaflet i hoved-bundlen.
 */
export default function FiskekrokIkon(props) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      {/* Krok-øye */}
      <circle cx="8" cy="5" r="1.6" />
      {/* Rett skaft ned, én jevn halvsirkel-bue i bunnen, og en rett
          krokspiss som peker opp igjen — klassisk fiskekrok-form.
          Koordinatene er valgt slik at hele omrisset (øye + skaft + bue +
          spiss) er balansert rundt midten av viewBox-en (12,12), slik at
          kroken står visuelt sentrert. */}
      <path d="M8 6.6V16a4 4 0 1 0 8 0v-3" />
    </svg>
  );
}
